export const normalizeUsername = (value = "") =>
  value.toString().trim().replace(/^@/, "").toLowerCase();

export const normalizeFullName = (value = "") =>
  value.toString().trim().replace(/\s+/g, " ").toLowerCase();

export const formatFullName = ({ fullName, firstName, lastName }) => {
  const safeFirst = firstName ? firstName.trim() : "";
  const safeLast = lastName ? lastName.trim() : "";
  const combined = [safeLast, safeFirst].filter(Boolean).join(" ");
  if (combined) {
    return combined;
  }

  if (fullName) {
    const normalized = fullName.toString().trim().replace(/\s+/g, " ");
    const parts = normalized.split(" ").filter(Boolean);
    if (parts.length >= 2) {
      return `${parts[0]} ${parts[1]}`;
    }
    return normalized;
  }

  return "";
};

export const formatDisplayName = ({ fullName, firstName, lastName, username }) => {
  const base = formatFullName({ fullName, firstName, lastName });
  const nick = normalizeUsername(username || "");

  if (base && nick) {
    return `${base} (${nick})`;
  }
  if (base) {
    return base;
  }
  if (nick) {
    return nick;
  }
  return "";
};
